import { createAction, stringDuckCreator } from '@atc/modular-redux';
export default function sortDuckCreator(_temp) {
  let {
    namespace = '',
    store = 'sort',
    storePath,
    initialState = '',
    ...rest
  } = _temp === void 0 ? {} : _temp;
  return stringDuckCreator({
    ...rest,
    initialState,
    namespace,
    store,
    storePath
  }).extend({
    creators: _ref => {
      let {
        types
      } = _ref;
      return {
        setSort: createAction(types.SET)
      };
    }
  });
}